import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, vShow as _vShow, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "header"
};
const _hoisted_2 = {
  class: "logo"
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "bgIcon"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  key: 0,
  class: "serarchWrap"
};
const _hoisted_8 = {
  class: "search2"
};
const _hoisted_9 = ["placeholder"];
const _hoisted_10 = {
  key: 1,
  class: "search2"
};
const _hoisted_11 = {
  class: "cp_con"
};
const _hoisted_12 = {
  id: "custom-show-hide-example2"
};
const _hoisted_13 = {
  class: "menu_info_main"
};
const _hoisted_14 = {
  class: "scroll_cont"
};
const _hoisted_15 = {
  id: "custom-show-hide-example2",
  class: "menu2"
};
const _hoisted_16 = {
  class: "menu_info_main"
};
const _hoisted_17 = {
  class: "scroll_cont"
};
const _hoisted_18 = {
  id: "custom-show-hide-example2",
  class: "menu2"
};
const _hoisted_19 = {
  class: "menu_info_main"
};
const _hoisted_20 = {
  class: "scroll_cont"
};
const _hoisted_21 = {
  class: "pic_list subject"
};
const _hoisted_22 = {
  class: "pic_list_info"
};
const _hoisted_23 = {
  class: "list01",
  id: "change_info"
};
const _hoisted_24 = {
  class: "totalsum"
};
const _hoisted_25 = {
  id: "search_total"
};
const _hoisted_26 = {
  key: 0,
  class: "totalsum"
};
const _hoisted_27 = {
  id: "search_total"
};
const _hoisted_28 = {
  class: "pic_list_info2"
};
const _hoisted_29 = {
  id: "search_condition",
  class: "condition"
};
const _hoisted_30 = ["onClick"];
const _hoisted_31 = ["onClick"];
const _hoisted_32 = ["onClick"];
const _hoisted_33 = ["innerHTML"];
const _hoisted_34 = ["onClick"];
const _hoisted_35 = {
  onclick: "",
  target: "_blank"
};
const _hoisted_36 = {
  class: "img_box2"
};
const _hoisted_37 = ["src"];
const _hoisted_38 = ["src"];
const _hoisted_39 = {
  key: 2,
  id: "con",
  class: "con1"
};
const _hoisted_40 = {
  class: "conList"
};
const _hoisted_41 = ["onClick"];
const _hoisted_42 = {
  onclick: "",
  target: "_blank"
};
const _hoisted_43 = {
  class: "img_box2"
};
const _hoisted_44 = ["src"];
const _hoisted_45 = ["src"];
const _hoisted_46 = {
  key: 3,
  id: "list",
  class: "list"
};
const _hoisted_47 = ["onClick"];
const _hoisted_48 = {
  onclick: "",
  target: "_blank"
};
const _hoisted_49 = {
  class: "dt"
};
const _hoisted_50 = {
  class: "dd"
};
const _hoisted_51 = {
  key: 4,
  class: "nodata"
};
const _hoisted_52 = {
  key: 5,
  class: "loading"
};
const _hoisted_53 = {
  class: "foot"
};
const _hoisted_54 = {
  class: "detailcontent subject"
};
const _hoisted_55 = {
  class: "container clearfix"
};
const _hoisted_56 = {
  class: "banner"
};
const _hoisted_57 = {
  class: "swiper-container gallery-top"
};
const _hoisted_58 = {
  class: "swiper-wrapper",
  id: "bgImg"
};
const _hoisted_59 = ["onClick"];
const _hoisted_60 = ["src"];
const _hoisted_61 = {
  class: "smallbox"
};
const _hoisted_62 = {
  class: "swiper-container gallery-thumbs"
};
const _hoisted_63 = {
  class: "swiper-wrapper",
  id: "smImg"
};
const _hoisted_64 = ["src"];
const _hoisted_65 = {
  class: "detailcon"
};
const _hoisted_66 = {
  key: 0,
  id: "detailinfo"
};
const _hoisted_67 = {
  key: 0
};
const _hoisted_68 = {
  key: 1
};
const _hoisted_69 = {
  key: 2
};
const _hoisted_70 = {
  key: 3
};
const _hoisted_71 = {
  key: 1,
  id: "detailinfo"
};
const _hoisted_72 = {
  key: 0
};
const _hoisted_73 = {
  key: 1
};
const _hoisted_74 = {
  key: 2
};
const _hoisted_75 = {
  key: 3
};
const _hoisted_76 = {
  key: 0,
  class: "sp1"
};
const _hoisted_77 = ["innerHTML"];
const _hoisted_78 = {
  key: 0,
  class: "sp1"
};
const _hoisted_79 = {
  key: 0,
  class: "sp1",
  style: {
    "white-space": "nowrap",
    "letter-spacing": "0",
    "width": "120px"
  }
};
const _hoisted_80 = {
  style: {
    "margin-left": "130px"
  }
};
const _hoisted_81 = {
  key: 0,
  class: "sp1"
};
const _hoisted_82 = {
  key: 0,
  class: "sp1"
};
const _hoisted_83 = {
  key: 0,
  class: "sp1"
};
const _hoisted_84 = {
  key: 0,
  class: "sp1"
};
const _hoisted_85 = ["innerHTML"];
const _hoisted_86 = {
  key: 1,
  class: "bigImg"
};
const _hoisted_87 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_tree = _resolveComponent("el-tree");
  const _component_font = _resolveComponent("font");
  const _component_Download = _resolveComponent("Download");
  const _component_el_icon = _resolveComponent("el-icon");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`collection ${$data.themeColor} fid_${_ctx.$route.query.fid}`)
  }, [$data.themeColor ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("span", {
    class: "btn-screen ydshow ab",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.ydshowmenu && $options.ydshowmenu(...args))
  }, _cache[30] || (_cache[30] = [_createElementVNode("i", null, null, -1)])), _createElementVNode("div", _hoisted_2, [_createElementVNode("a", {
    onClick: _cache[1] || (_cache[1] = (...args) => $options.toIndex && $options.toIndex(...args))
  }, [!$data.logoImg ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString($data.title), 1)) : (_openBlock(), _createElementBlock("img", {
    key: 1,
    src: $data.logoImg
  }, null, 8, _hoisted_4))])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
    src: require(`../../assets/collection/title_t_${$data.themeColor}.png`)
  }, null, 8, _hoisted_6)]), _createElementVNode("div", {
    class: "ydshow searchbtn ab",
    onClick: _cache[2] || (_cache[2] = (...args) => $options.ydshowsearch && $options.ydshowsearch(...args))
  }), _ctx.$route.query.fid == $data.JXZYXY && $data.ydsearch ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_el_select, {
    modelValue: $data.jxSearchType,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.jxSearchType = $event),
    placeholder: "请选择",
    class: "serarchBlock leftSearch",
    "popper-class": "collectSearch",
    "popper-append-to-body": false,
    onChange: $options.changeJxSearch
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.jxSearchTypes, (item, index) => {
      return _openBlock(), _createBlock(_component_el_option, {
        key: index,
        label: item.title,
        value: index
      }, null, 8, ["label", "value"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue", "onChange"]), _createElementVNode("div", _hoisted_8, [$data.jxSearchType < 2 || $data.jxSearchType > 3 ? _withDirectives((_openBlock(), _createElementBlock("input", {
    key: 0,
    name: "topKeyword",
    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.Keyword = $event),
    id: "topKeyword",
    type: "text",
    placeholder: `请输入${$data.jxSearchTypes[$data.jxSearchType].title}`,
    class: "input03",
    onKeyup: _cache[5] || (_cache[5] = _withKeys($event => $options.topSearch(), ["enter"]))
  }, null, 40, _hoisted_9)), [[_vModelText, $data.Keyword]]) : _createCommentVNode("", true), $data.jxSearchType == 2 || $data.jxSearchType == 3 ? (_openBlock(), _createBlock(_component_el_select, {
    key: 1,
    modelValue: $data.jxSearchConSelect,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.jxSearchConSelect = $event),
    placeholder: `请选择${$data.jxSearchTypes[$data.jxSearchType].title}`,
    class: "serarchBlock conSearch",
    "popper-class": "collectSearch",
    "popper-append-to-body": false
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.jxSearchCons, (item, index) => {
      return _openBlock(), _createBlock(_component_el_option, {
        key: index,
        label: item.title,
        value: item.title
      }, null, 8, ["label", "value"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue", "placeholder"])) : _createCommentVNode("", true), _createElementVNode("input", {
    name: "",
    onClick: _cache[7] || (_cache[7] = $event => $options.topSearch()),
    class: "input04",
    value: "搜索"
  }), _createElementVNode("span", {
    class: "ydshow icon-close",
    onClick: _cache[8] || (_cache[8] = (...args) => $options.ydhidesearch && $options.ydhidesearch(...args))
  })])])) : _createCommentVNode("", true), _ctx.$route.query.fid != $data.JXZYXY ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_10, [_withDirectives(_createElementVNode("input", {
    name: "topKeyword",
    "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $data.Keyword = $event),
    id: "topKeyword",
    type: "text",
    placeholder: "关键词搜索",
    class: "input03",
    onKeyup: _cache[10] || (_cache[10] = _withKeys($event => $options.topSearch(), ["enter"]))
  }, null, 544), [[_vModelText, $data.Keyword]]), _createElementVNode("input", {
    name: "",
    onClick: _cache[11] || (_cache[11] = $event => $options.topSearch()),
    class: "input04",
    value: "搜索"
  }), _createElementVNode("span", {
    class: "ydshow icon-close",
    onClick: _cache[12] || (_cache[12] = (...args) => $options.ydhidesearch && $options.ydhidesearch(...args))
  })], 512)), [[_vShow, $data.ydsearch]]) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_11, [$data.ydmenu ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "shadeBlock",
    onClick: _cache[13] || (_cache[13] = (...args) => $options.shadefun && $options.shadefun(...args))
  })) : _createCommentVNode("", true), _createElementVNode("div", {
    class: _normalizeClass(["menu", `${$data.ydmenu ? 'on' : ''} ${$data.themeColor}`])
  }, [_createElementVNode("div", {
    class: _normalizeClass(`newOpen ${$data.theme.needYear == 0 ? 'newOpenOnly' : ''} ${_ctx.$route.query.fid == 212368 ? 'jingmen' : ''}`)
  }, [_createElementVNode("div", {
    class: _normalizeClass(!$data.showIndex ? 'active' : ''),
    onClick: _cache[14] || (_cache[14] = $event => $data.showIndex = 0)
  }, _toDisplayString(_ctx.$route.query.fid == $data.JXZYXY ? '所属展厅' : '藏品分类'), 3), _ctx.$route.query.fid != $data.JXZYXY && $data.theme.needYear == 1 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass($data.showIndex == 1 ? 'active' : ''),
    onClick: _cache[15] || (_cache[15] = $event => $data.showIndex = 1)
  }, "年代", 2)) : _createCommentVNode("", true), $data.showKc && _ctx.$route.query.fid == $data.JXZYXY ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: _normalizeClass($data.showIndex == 1 ? 'active' : ''),
    onClick: _cache[16] || (_cache[16] = $event => $data.showIndex = 1)
  }, "典型矿床", 2)) : _createCommentVNode("", true), _ctx.$route.query.fid == 212368 ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    class: _normalizeClass($data.showIndex == 2 ? 'active' : ''),
    onClick: _cache[17] || (_cache[17] = $event => $data.showIndex = 2)
  }, "等级", 2)) : _createCommentVNode("", true)], 2), _createElementVNode("div", _hoisted_12, [_withDirectives(_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createVNode(_component_el_tree, {
    ref: "tree",
    "node-key": "title",
    props: $data.props,
    data: $data.typeData,
    "empty-text": "暂无数据",
    "show-checkbox": "",
    onNodeClick: $options.nodeExpand,
    onCheck: $options.handleCheckChange
  }, null, 8, ["props", "data", "onNodeClick", "onCheck"])])], 512), [[_vShow, !$data.showIndex]])]), _createElementVNode("div", _hoisted_15, [_withDirectives(_createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_withDirectives(_createVNode(_component_el_tree, {
    ref: "tree4",
    "node-key": "title",
    props: $data.props,
    data: $data.eraData,
    "empty-text": "暂无数据",
    "show-checkbox": "",
    accordion: "",
    "check-strictly": "",
    onCheck: $options.checkChangeKuangChuang
  }, null, 8, ["props", "data", "onCheck"]), [[_vShow, _ctx.$route.query.fid == $data.JXZYXY]]), _withDirectives(_createVNode(_component_el_tree, {
    ref: "tree2",
    "node-key": "title",
    props: $data.props,
    data: $data.eraData,
    "empty-text": "暂无数据",
    "show-checkbox": "",
    onCheck: $options.checkChangeEra
  }, null, 8, ["props", "data", "onCheck"]), [[_vShow, _ctx.$route.query.fid != $data.JXZYXY]])])], 512), [[_vShow, $data.showIndex == 1]])]), _createElementVNode("div", _hoisted_18, [_withDirectives(_createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createVNode(_component_el_tree, {
    ref: "tree3",
    "node-key": "title",
    props: $data.props,
    data: $data.levelData,
    "empty-text": "暂无数据",
    "show-checkbox": "",
    onCheck: $options.checkChangeLevel
  }, null, 8, ["props", "data", "onCheck"])])], 512), [[_vShow, $data.showIndex == 2]])])], 2), !$data.ldflag ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "windowPlaceholder",
    onClick: _cache[18] || (_cache[18] = $event => $data.ldflag = true)
  })) : _createCommentVNode("", true), _createElementVNode("div", {
    class: "content",
    ref: "content",
    onScroll: _cache[23] || (_cache[23] = (...args) => $options.scrollEvent && $options.scrollEvent(...args))
  }, [_createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createElementVNode("ul", _hoisted_23, [_createElementVNode("li", {
    class: _normalizeClass({
      'on': $data.listImgFlag
    })
  }, [_createElementVNode("a", {
    href: "javascript:;",
    onClick: _cache[19] || (_cache[19] = $event => $options.changeType(true))
  })], 2), _createElementVNode("li", {
    class: _normalizeClass({
      'on': !$data.listImgFlag
    })
  }, [_createElementVNode("a", {
    href: "javascript:;",
    onClick: _cache[20] || (_cache[20] = $event => $options.changeType(false))
  })], 2)]), _createElementVNode("span", _hoisted_24, [_cache[31] || (_cache[31] = _createTextVNode("共")), _createElementVNode("strong", _hoisted_25, " " + _toDisplayString($data.total), 1), _cache[32] || (_cache[32] = _createTextVNode("套"))]), $data.totalNum ? (_openBlock(), _createElementBlock("span", _hoisted_26, [_createElementVNode("strong", _hoisted_27, " " + _toDisplayString($data.totalNum), 1), _cache[33] || (_cache[33] = _createTextVNode("件  "))])) : _createCommentVNode("", true)]), _withDirectives(_createElementVNode("div", _hoisted_28, [_createElementVNode("span", _hoisted_29, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.checkedTree, (item, index) => {
    return _openBlock(), _createBlock(_component_font, {
      key: index
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(item.title), 1), _createElementVNode("a", {
        href: "javascript:;",
        onClick: $event => $options.removetype(index)
      }, null, 8, _hoisted_30)]),
      _: 2
    }, 1024);
  }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.checkedEra, (item, index) => {
    return _openBlock(), _createBlock(_component_font, {
      key: index
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(item.title), 1), _createElementVNode("a", {
        href: "javascript:;",
        onClick: $event => $options.removetype(index, 'era')
      }, null, 8, _hoisted_31)]),
      _: 2
    }, 1024);
  }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.checkedLevel, (item, index) => {
    return _openBlock(), _createBlock(_component_font, {
      key: index
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(item.title), 1), _createElementVNode("a", {
        href: "javascript:;",
        onClick: $event => $options.removetype(index, 'level')
      }, null, 8, _hoisted_32)]),
      _: 2
    }, 1024);
  }), 128))]), _createElementVNode("a", {
    href: "javascript:;",
    class: "del",
    onClick: _cache[21] || (_cache[21] = $event => $options.removeAll())
  }, "清空全部")], 512), [[_vShow, $data.checkedTree.length || $data.checkedEra.length || $data.checkedLevel.length]]), _createElementVNode("div", {
    class: _normalizeClass(`kuangchuang ${$data.showKcDesc ? 'show' : 'hide'}`),
    ref: "kuangchuangDesc"
  }, [_createElementVNode("p", {
    innerHTML: $data.kuangchuangDetail.desc
  }, null, 8, _hoisted_33)], 2), $data.kuangchuangDetail.desc && $data.showKcDesc != -1 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass(`showKcDesc ${$data.showKcDesc ? 'shouqi' : ''}`),
    onClick: _cache[22] || (_cache[22] = $event => $data.showKcDesc = !$data.showKcDesc)
  }, [_createTextVNode(_toDisplayString($data.showKcDesc ? '收起' : '展开'), 1), _cache[34] || (_cache[34] = _createElementVNode("i", null, null, -1))], 2)) : _createCommentVNode("", true), $data.listImgFlag && $data.theme.styleType == 2 ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    id: "con",
    class: _normalizeClass(`${$data.theme.styleType == 2 ? 'con2' : 'con1'}`)
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.List, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: _normalizeClass(`pic ${$data.theme.styleType == 2 ? 'pic2' : ''}`),
      key: index,
      onClick: $event => $options.godetail(item)
    }, [_createElementVNode("a", _hoisted_35, [_createElementVNode("div", _hoisted_36, [item.primaryImage ? (_openBlock(), _createElementBlock("img", {
      key: 0,
      class: "img001",
      src: item.primaryImage
    }, null, 8, _hoisted_37)) : _createCommentVNode("", true), !item.primaryImage && $data.themeColor ? (_openBlock(), _createElementBlock("img", {
      key: 1,
      src: require(`../../assets/collection/primary_${$data.themeColor}.png`)
    }, null, 8, _hoisted_38)) : _createCommentVNode("", true)]), _createElementVNode("p", null, _toDisplayString(item.antiqueName), 1)])], 10, _hoisted_34);
  }), 128))], 2)) : _createCommentVNode("", true), $data.listImgFlag && $data.theme.styleType != 2 ? (_openBlock(), _createElementBlock("div", _hoisted_39, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.conList, con => {
    return _openBlock(), _createElementBlock("div", _hoisted_40, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(con, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        class: "pic",
        key: index,
        onClick: $event => $options.godetail(item)
      }, [_createElementVNode("a", _hoisted_42, [_createElementVNode("div", _hoisted_43, [item.primaryImage ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        class: "img001",
        src: item.primaryImage
      }, null, 8, _hoisted_44)) : _createCommentVNode("", true), !item.primaryImage && $data.themeColor ? (_openBlock(), _createElementBlock("img", {
        key: 1,
        src: require(`../../assets/collection/primary_${$data.themeColor}.png`)
      }, null, 8, _hoisted_45)) : _createCommentVNode("", true)]), _createElementVNode("p", null, _toDisplayString(item.antiqueName), 1)])], 8, _hoisted_41);
    }), 128))]);
  }), 256))])) : _createCommentVNode("", true), !$data.listImgFlag ? (_openBlock(), _createElementBlock("div", _hoisted_46, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.List, (item, index) => {
    return _openBlock(), _createElementBlock("dl", {
      key: index,
      onClick: $event => $options.godetail(item),
      style: _normalizeStyle({
        '--bgColor': $data.bgColor
      })
    }, [_createElementVNode("a", _hoisted_48, [_createElementVNode("div", _hoisted_49, _toDisplayString(item.antiqueName), 1), _createElementVNode("div", _hoisted_50, [_createElementVNode("span", null, _toDisplayString(item.antiqueCode), 1), _createElementVNode("span", null, _toDisplayString(item.texture), 1), _createElementVNode("span", null, _toDisplayString(item.era), 1), _cache[35] || (_cache[35] = _createElementVNode("i", null, null, -1))])])], 12, _hoisted_47);
  }), 128))])) : _createCommentVNode("", true), $data.total == 0 && !$data.isLoading ? (_openBlock(), _createElementBlock("div", _hoisted_51, "暂无数据")) : _createCommentVNode("", true), $data.isLoading ? (_openBlock(), _createElementBlock("div", _hoisted_52, "加载中")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_53, [_createElementVNode("p", null, [_createElementVNode("span", null, _toDisplayString($data.antiquetitle), 1)])])], 544), !$data.ldflag ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    class: _normalizeClass(["content", {
      'style1': !$data.ldflag
    }]),
    ref: "content"
  }, [_createElementVNode("div", _hoisted_54, [_createElementVNode("span", {
    class: "share",
    onClick: _cache[24] || (_cache[24] = (...args) => $options.golist && $options.golist(...args))
  }, "×"), _createElementVNode("div", _hoisted_55, [_createElementVNode("div", _hoisted_56, [_createElementVNode("div", _hoisted_57, [_createElementVNode("div", _hoisted_58, [_ctx.item !== '' ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList($data.detail.bannerArr, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "swiper-slide",
      key: index,
      onClick: $event => $options.swipertop(item),
      onMousemove: _cache[25] || (_cache[25] = (...args) => $options.moveMagnifier && $options.moveMagnifier(...args)),
      onMouseenter: _cache[26] || (_cache[26] = (...args) => $options.showMagnifier && $options.showMagnifier(...args)),
      onMouseleave: _cache[27] || (_cache[27] = (...args) => $options.hideMagnifier && $options.hideMagnifier(...args))
    }, [_createElementVNode("img", {
      src: item,
      ref_for: true,
      ref: "mainImage"
    }, null, 8, _hoisted_60), $data.showMagnifierFlag ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "magnifier",
      ref_for: true,
      ref: "magnifier"
    }, null, 512)) : _createCommentVNode("", true)], 40, _hoisted_59);
  }), 128)) : _createCommentVNode("", true)]), _cache[36] || (_cache[36] = _createElementVNode("div", {
    class: "swiper-pagination"
  }, null, -1))]), _createElementVNode("div", _hoisted_61, [_createElementVNode("div", _hoisted_62, [_createElementVNode("div", _hoisted_63, [_ctx.item !== '' ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList($data.detail.bannerArr, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "swiper-slide",
      key: index
    }, [_createElementVNode("img", {
      src: item
    }, null, 8, _hoisted_64)]);
  }), 128)) : _createCommentVNode("", true)])]), _cache[37] || (_cache[37] = _createElementVNode("div", {
    class: "swiper-button-next"
  }, null, -1)), _cache[38] || (_cache[38] = _createElementVNode("div", {
    class: "swiper-button-prev"
  }, null, -1))])]), _createElementVNode("div", _hoisted_65, [_createElementVNode("h2", null, [_createTextVNode(_toDisplayString($data.detail.antiqueName), 1), _ctx.$route.query.fid != 165400 ? (_openBlock(), _createBlock(_component_el_icon, {
    key: 0,
    onClick: $options.downloadImg
  }, {
    default: _withCtx(() => [_createVNode(_component_Download)]),
    _: 1
  }, 8, ["onClick"])) : _createCommentVNode("", true)]), _ctx.$route.query.fid != $data.JXZYXY ? (_openBlock(), _createElementBlock("ul", _hoisted_66, [_createElementVNode("li", null, [_cache[39] || (_cache[39] = _createElementVNode("span", {
    class: "sp1"
  }, "藏品编号", -1)), _createElementVNode("span", null, _toDisplayString($data.detail.antiqueCode), 1)]), $data.detail.era ? (_openBlock(), _createElementBlock("li", _hoisted_67, [_cache[40] || (_cache[40] = _createElementVNode("span", {
    class: "sp1"
  }, "年代", -1)), _createElementVNode("span", null, _toDisplayString(_ctx.$route.query.fid == 42268 && $data.detail.era.split('/').length > 1 ? $data.detail.era.split('/').slice(1).join('/') : $data.detail.era), 1)])) : _createCommentVNode("", true), $data.detail.antiqueTypename ? (_openBlock(), _createElementBlock("li", _hoisted_68, [_cache[41] || (_cache[41] = _createElementVNode("span", {
    class: "sp1"
  }, "分类", -1)), _createElementVNode("span", null, _toDisplayString($data.detail.antiqueTypename), 1)])) : _createCommentVNode("", true), $data.detail.texture ? (_openBlock(), _createElementBlock("li", _hoisted_69, [_cache[42] || (_cache[42] = _createElementVNode("span", {
    class: "sp1"
  }, "质地", -1)), _createElementVNode("span", null, _toDisplayString($data.detail.texture), 1)])) : _createCommentVNode("", true), $data.detail.detailSize != null && $data.detail.detailSize != '' ? (_openBlock(), _createElementBlock("li", _hoisted_70, [_cache[43] || (_cache[43] = _createElementVNode("span", {
    class: "sp1"
  }, "外形尺寸", -1)), _createElementVNode("span", null, _toDisplayString($data.detail.detailSize), 1)])) : _createCommentVNode("", true), _createElementVNode("li", null, [_cache[44] || (_cache[44] = _createElementVNode("span", {
    class: "sp1"
  }, "完残程度", -1)), _createElementVNode("span", null, _toDisplayString($data.detail.incompleteLevel), 1)])])) : (_openBlock(), _createElementBlock("ul", _hoisted_71, [_createElementVNode("li", null, [_cache[45] || (_cache[45] = _createElementVNode("span", {
    class: "sp1"
  }, "藏品编号", -1)), _createElementVNode("span", null, _toDisplayString($data.detail.antiqueCode), 1)]), $data.detail.exhibitionHall ? (_openBlock(), _createElementBlock("li", _hoisted_72, [_cache[46] || (_cache[46] = _createElementVNode("span", {
    class: "sp1"
  }, "所属展厅", -1)), _createElementVNode("span", null, _toDisplayString($data.detail.exhibitionHall), 1)])) : _createCommentVNode("", true), $data.detail.kuangchuang ? (_openBlock(), _createElementBlock("li", _hoisted_73, [_cache[47] || (_cache[47] = _createElementVNode("span", {
    class: "sp1"
  }, "所属展厅", -1)), _createElementVNode("span", null, _toDisplayString($data.detail.kuangchuang), 1)])) : _createCommentVNode("", true), $data.detail.classifyCode ? (_openBlock(), _createElementBlock("li", _hoisted_74, [_cache[48] || (_cache[48] = _createElementVNode("span", {
    class: "sp1"
  }, "产地", -1)), _createElementVNode("span", null, _toDisplayString($data.detail.classifyCode), 1)])) : _createCommentVNode("", true), $data.detail.originName ? (_openBlock(), _createElementBlock("li", _hoisted_75, [$data.detail.originName ? (_openBlock(), _createElementBlock("span", _hoisted_76, "化学式")) : _createCommentVNode("", true), _createElementVNode("span", {
    innerHTML: $data.detail.originName
  }, null, 8, _hoisted_77)])) : _createCommentVNode("", true), _createElementVNode("li", null, [$data.detail.generalLength ? (_openBlock(), _createElementBlock("span", _hoisted_78, "结构构造")) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString($data.detail.generalLength), 1)]), _createElementVNode("li", null, [$data.detail.generalHeight ? (_openBlock(), _createElementBlock("span", _hoisted_79, "矿物成分及其含量")) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_80, _toDisplayString($data.detail.generalHeight), 1)]), _createElementVNode("li", null, [$data.detail.incompleteState ? (_openBlock(), _createElementBlock("span", _hoisted_81, "颜色")) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString($data.detail.incompleteState), 1)]), _createElementVNode("li", null, [$data.detail.generalWidth ? (_openBlock(), _createElementBlock("span", _hoisted_82, "组成")) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString($data.detail.generalWidth), 1)]), _createElementVNode("li", null, [$data.detail.donor ? (_openBlock(), _createElementBlock("span", _hoisted_83, "捐赠人")) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString($data.detail.donor), 1)]), _createElementVNode("li", null, [$data.detail.donorTime ? (_openBlock(), _createElementBlock("span", _hoisted_84, "捐赠时间")) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString($data.detail.donorTime), 1)])])), _createElementVNode("div", {
    class: "remark",
    id: "remark",
    innerHTML: $data.detail.remark
  }, null, 8, _hoisted_85), _createElementVNode("span", {
    class: "share shareMobile",
    onClick: _cache[28] || (_cache[28] = (...args) => $options.golist && $options.golist(...args))
  }, "×")])])])], 2)) : _createCommentVNode("", true)]), $data.bigImg ? (_openBlock(), _createElementBlock("div", _hoisted_86, [_createElementVNode("div", {
    class: "closeBig",
    onClick: _cache[29] || (_cache[29] = $event => $data.bigImg = '')
  }, "×"), _createElementVNode("img", {
    src: $data.bigImg
  }, null, 8, _hoisted_87)])) : _createCommentVNode("", true)], 2);
}